import { SxProps, Theme } from '@mui/material';

export const styles: Record<'icon', SxProps<Theme>> = {
  icon: {
    minWidth: 48,
  },
};
